import { render, staticRenderFns } from "./ExistingCustomer.vue?vue&type=template&id=22ad5e86"
import script from "./ExistingCustomer.vue?vue&type=script&lang=js"
export * from "./ExistingCustomer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports